import axios from "axios";
import 'font-awesome/css/font-awesome.min.css'

const axiosInterface = axios.create({});

axiosInterface.interceptors.request.use(async (req:any )=>{
    document.body.classList.add('loading-indicator');
    return req;
}, (error:any) => {
    document.body.classList.remove('loading-indicator');
    return Promise.reject(error)
})

axiosInterface.interceptors.response.use(resp => {
    document.body.classList.remove('loading-indicator');
    if(resp.status === 401){
        document.body.classList.remove('loading-indicator');
        window.location.href = '/';
    }
    // if(resp.data.errors.detail === 'token expired'){
    //     document.body.classList.remove('loading-indicator');
    //     window.location.href = '/';
    // }
    return resp;
}, (error:any) =>{
    document.body.classList.remove('loading-indicator');
    if(error.response.data.errors.detail === 'token expired'){
        document.body.classList.remove('loading-indicator');
        window.location.href = '/';
    }
    return Promise.reject(error)
});

export default axiosInterface;